<template>
  <div :class="componentClassName">
    <label class="a-current-phone__label">ユーザーにつなぐ</label>
    <!-- <select v-model="currentValue" class="a-current-phone__select" :disabled="disabled" @change="handleChange">
      <slot></slot>
    </select>
    <div class="a-current-phone__icon-container">
      <a-icon icon="caret-down" color="orange" />
    </div> -->
    <a-select-field-user-status
      id="a-current-phone-select"
      v-model="modelValue"
      class="a-current-phone__select"
      :options="clientNameList"
      :searchable="true"
      :maxlength="20"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AIcon from '@/components/atoms/icon';
import ASelectFieldUserStatus from '@/components/atoms/select-field-user-status';

export default {
  name: 'a-current-phone',
  components: {
    ASelectFieldUserStatus,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    selectedNumber: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clientNameList: {
      type: Array,
      default: null,
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      modelValue: '',
      currentValue: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-current-phone');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    modelValue(val, oldVal) {
      this.setCurrentValue(this.modelValue);
    },
    selectedNumber(val, oldVal) {
      this.modelValue = val;
    },
  },
  created() {
    if (this.selectedNumber) {
      this.modelValue = this.selectedNumber;
    }
  },
  mounted() {
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
      // #5897
    } else if (this.clientNameList.length > 0) {
      this.modelValue = this.clientNameList[0]['value'];
    }
  },
  methods: {
    setCurrentValue(value) {
      this.currentValue = value;
    },
    handleChange(e) {
      this.$emit('update:modelValue', this.modelValue);
      this.$emit('change', this.modelValue);
    },
  },
};
</script>
